import React, { useEffect, useState } from "react";
import {
  Box,
  Icon,
  SimpleGrid,
  useColorModeValue,
  Spinner,
  Text,
  Stack,
  Button,
  Flex
} from "@chakra-ui/react";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import {
  FaMoneyBill
} from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import TransactionTable from "../transactions/components/TransactionTable";
import { logger } from "views/models/logging";
import { abs } from "stylis";
import { formatYMD } from "views/helpers/date";
import { MdArrowBack } from "react-icons/md";

export default function BalanceCheck({ showTrxns = true, clientId = null, clientName = null, adminInvoke = false, nDays = 1, showReportPage = null }) {
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const [balance, setBalance] = useState(0.00);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [trxns, setTrxns] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [filter, setFilterState] = useState(false);
  const [reportDate, setReportDate] = useState(new Date().toLocaleDateString("en-GB", { timeZone: 'Africa/Lagos' }));
  let navigate = useHistory();

  useEffect(() => {
    const clientInfo = sessionStorage.getItem('clientInfo');
    const key = sessionStorage.getItem('token');

    if (clientInfo) {
      let { agentId, role } = JSON.parse(clientInfo);
      if (!adminInvoke) {
        if (role === 'Admin') {
          navigate.push('/auth');
        }
      }
      else {
        agentId = clientId;
      }

      const apiHeader = {
        headers: {
          "authorization": `Bearer ${key}`
        }
      }

      const fetchData = () => {
        getBalance(agentId, reportDate, apiHeader);
        if (showTrxns)
          getTrxns(agentId, reportDate, apiHeader);
      }
      fetchData();

      const intervalData = setInterval(fetchData, 300000);

      return () => clearInterval(intervalData);
    }
    else
      navigate.push('/auth');

  }, [reportDate]);

  const getBalance = async (agentId, date, header) => {
    setBalanceLoading(true);
    const params = {
      agentId: agentId,
      balanceDate: formatYMD(date)
    };

    try {
      const response = await axios.post(getAPIEndpoint('balance'), params, header);
      if (response) {
        const { status, data } = response.data;
        if (status === 'success' && data)
          setBalance(parseFloat(data[0].balance));
        else
          setBalance(0);
      }

    } catch (error) {
      await logger({ task: "Balance check", error: error.toString() });
    }
    setBalanceLoading(false);
  }

  const getTrxns = async (agentId, date, header) => {
    setIsloading(true);

    const params = {
      agentId: agentId,
      transDate: formatYMD(date)
    };

    try {
      const response = await axios.post(getAPIEndpoint('trxns'), params, header);
      if (response) {
        const { status, data } = response.data;
        if (status === 'success' && data)
          setTrxns(data);
        else
          setTrxns([]);
      }
    } catch (error) {
      await logger({ task: "Get transactions", error: error.toString() });
    }

    setIsloading(false);
  }

  const props = {
    isLoading,
    reportDate,
    filter,
    setReportDate,
    setFilterState,
    trxns,
    nDays
  }
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {clientName &&
        <Stack direction={'row'} spacing={7}>
          <Flex pt={'7px'}>
            <Button onClick={() => showReportPage()} size='sm' leftIcon={<MdArrowBack />} colorScheme='blue' variant='outline'>
              Back
            </Button>
          </Flex>

          <Text color={'#744210'} fontSize={'3xl'} pb={3}>{clientName}</Text>
        </Stack>
      }
      <SimpleGrid
        columns={{ base: 1, md: 1, lg: 1, "2xl": 1 }}
        gap='20px'
        mb='20px'>
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={FaMoneyBill} color='blue.700' />
              }
            />
          }
          name='Available Balance'
          value={balanceLoading ? <Spinner /> : <Box color={balance > 0 ? 'green.600' : 'red.600'}>{abs(balance).toLocaleString('en-US')} NGN</Box>}
        />
      </SimpleGrid>
      {showTrxns && <TransactionTable {...props} />}
    </Box>
  );
}
